import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const PHASES = ["INSPIRA", "TRATTIENI", "ESPIRA", "TRATTIENI"];
const SCALES = [1.5, 1.5, 1, 1];

export default function BreathPacer() {
  const [running, setRunning] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!running) return;
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, [running]);

  const phaseIdx = Math.floor(tick / 4) % 4;
  const remaining = 4 - (tick % 4);
  const cycles = Math.floor(tick / 16);

  return (
    <div data-testid="protocol-breath-pacer-widget" className="mt-6">
      <div className="relative h-48 flex items-center justify-center">
        <motion.div
          animate={{ scale: running ? SCALES[phaseIdx] : 1 }}
          transition={{
            duration: running && phaseIdx % 2 === 0 ? 4 : 0.4,
            ease: "linear",
          }}
          className="w-24 h-24 border-2 border-neon neon-shadow flex items-center justify-center bg-neon/5"
        >
          <span className="font-display font-black text-3xl text-white">
            {running ? remaining : "4"}
          </span>
        </motion.div>
      </div>
      <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.2em]">
        <span className="text-neon">{running ? PHASES[phaseIdx] : "Pronto"}</span>
        <span className="text-[#858599]">Cicli: {cycles}</span>
      </div>
      <button
        data-testid="protocol-breath-start-btn"
        onClick={() => {
          setRunning((r) => !r);
          if (!running) setTick(0);
        }}
        className="mt-4 w-full border border-neon/50 text-neon text-xs font-mono uppercase tracking-[0.25em] px-4 py-3 hover:bg-neon hover:text-black transition-colors"
      >
        {running ? "Ferma Protocollo" : "Avvia Respirazione 4×4"}
      </button>
    </div>
  );
}
